import { render, staticRenderFns } from "./userInput.vue?vue&type=template&id=5b896cf2&"
import script from "./userInput.vue?vue&type=script&lang=js&"
export * from "./userInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports